export const defaultMenuList = () => [
	{
		id: 1,
		name: 'Dados da Disponibilidade',
		tag: 'availability',
		active: false,
		completed: false,
		skiped: false,
		editing: false,
	},
	{
		id: 2,
		name: 'Mapear Campos de Unidades',
		tag: 'unit-map-fields',
		active: false,
		completed: false,
		skiped: false,
		editing: false,
	},
	{
		id: 3,
		name: 'Indexadores para Proposta',
		tag: 'proposal-indexers',
		active: false,
		completed: false,
		skiped: false,
		editing: false,
	},
]

export const defaultActionList = () => [
		{
			id: 1,
			name: 'Visualizar Disponibilidade',
			action: 'redirect--show-availability',
			check: false,
		},
		{
			id: 2,
			name: 'Integrar nova Disponibilidade',
			action: 'redirect--new-availability',
			check: false,
		},
		{
			id: 3,
			name: 'Gerenciar Integrações ERP',
			action: 'redirect--manager-integrations',
			check: false,
		},
		{
			id: 4,
			name: 'Visualizar Empreendimentos Integrados',
			action: 'redirect--integrated-products',
			check: false,
		},
	]